import { Component, Input } from '@angular/core';
import { NoteSection } from 'src/app/model/section/note-section';

@Component({
  selector: 'app-additional-page-emergency-banner',
  templateUrl: './additional-page-emergency-banner.component.html',
  styleUrls: ['./additional-page-emergency-banner.component.scss']
})
export class AdditionalPageEmergencyBannerComponent {
  @Input() emergencyBanners: NoteSection[] = [];
}
